import { ENV } from "./constants/env";
import { authBearerToken } from "utils/auth";
import axios from "axios";
import { API_PATHS } from "utils/paths";

const DOCSEARCH_BUTTON_CLASS = "DocSearch-Button";
/**
 * Sanitize the docs url for local development
 * @param {String} url - indexed url from Algolia
 */
export const prepareDocsUrl = (url, env = process.env.NODE_ENV) => {
  const DOCS_ROOT_RE = new RegExp(`https://priceblocs.com`);
  return env !== ENV.PRODUCTION ? url.replace(DOCS_ROOT_RE, "") : url;
};

export const fetchAuthedDocsPreview = async ({ pathname }) => {
  try {
    const { data } = await axios({
      method: "get",
      url: API_PATHS.DOCS_PREVIEW,
      headers: authBearerToken(),
      params: { pathname }
    });

    return data;
  } catch (error) {
    console.log(`fetchAuthedDocsPreview ${pathname}`, error);
    return error;
  }
};

export const showDocsModal = () => {
  try {
    document.getElementsByClassName(DOCSEARCH_BUTTON_CLASS)[0].click();
  } catch (err) {
    console.error(err);
  }
};
